<button class="btn" [ngClass]="classes" (click)="onClick()" (keyup.enter)="allowKeyup&& onClick()" [disabled]="disabled"
    [attr.type]="submit?'submit':'button'">
    <em class="icon">{{icon}}</em> {{label}}
</button>
